import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/messages';
import {
  getCurrentJomVictimsIds,
  getInjuredVictims,
  resolveInjuredVictims,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { JudgementOnMeritsType } from 'containers/LawyerLegalProceedingsPage/typings';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Listings } from 'containers/AppContainer/typings';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import CivilWithNonCompensation from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilWithNonCompensation';
import JudgementForNonCompensation from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementForNonCompensation';
import {
  JUDGEMENT_EXPERTISE_TYPES,
  MODE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { VictimType } from 'typings/globalTypes';

export interface InjuredVictimProps {
  intl: IntlShape;
  victims?: VictimType[];
  judgementOnMerits: JudgementOnMeritsType;
  setJudgementOnMeritsRequest: Function;
  judgementOnMeritsRequest: any;
  judgementAddDocuments: JudgementADDDocumentType[];
  isMultiple?: boolean | undefined;
  currentJom?: any;
  listings: Listings;
  sagisVictimInfo: any;
  mode?: string;
  setJudgement: Function;
  judgement: any;
  jomAssociatedVictims?: number[] | undefined;
}

const InjuredVictim: React.FC<InjuredVictimProps> = (props): JSX.Element => {
  const currentJomVictimsIds = getCurrentJomVictimsIds(props.currentJom);
  const injuredVictim = resolveInjuredVictims(
    getInjuredVictims(props.judgementAddDocuments, get(props, 'victims', [])),
    get(props, 'jomAssociatedVictims', []),
    props.isMultiple,
    currentJomVictimsIds,
  );
  return (
    <main>
      {isEmpty(props.judgementOnMerits) && !isEmpty(injuredVictim) && (
        <div className="judgement-add-doc">
          <div className="judgement-on-merits-title">
            {translate(messages.injuredVictim, props)}
          </div>

          {injuredVictim.map((victim: VictimType) => (
            <div style={{ marginBottom: '40px' }}>
              <div key={victim.id} className="victims">
                <Grid container item spacing={2}>
                  <Grid item xs={3} className="victim-item">
                    {featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO) &&
                    !isEmpty(
                      getVictimFromSagisInfo(
                        get(victim, 'victimKey'),
                        props.sagisVictimInfo,
                      ),
                    )
                      ? `${get(
                          getVictimFromSagisInfo(
                            get(victim, 'victimKey'),
                            props.sagisVictimInfo,
                          ),
                          'victimFirstName',
                          '',
                        )} ${get(
                          getVictimFromSagisInfo(
                            get(victim, 'victimKey'),
                            props.sagisVictimInfo,
                          ),
                          'victimLastName',
                          '',
                        )}`
                      : `${victim.firstName} ${victim.lastName}`}
                  </Grid>
                  {featureService.hasFeature(
                    FEATURES.REASONS_FOR_NON_COMPENSATION,
                  ) ? (
                    <JudgementForNonCompensation
                      victim={victim}
                      setJudgementOnMeritsRequest={
                        props.setJudgementOnMeritsRequest
                      }
                      civilJudgements={[]}
                      judgementOnMeritsRequest={props.judgementOnMeritsRequest}
                      listings={props.listings}
                      judgementForNonCompensation={
                        JUDGEMENT_EXPERTISE_TYPES.NON_COMPENSATION
                      }
                      setJudgement={props.setJudgement}
                      judgement={props.judgement}
                      modeType={MODE_TYPES.FORM}
                      isDisabled={false}
                    />
                  ) : (
                    <CivilWithNonCompensation
                      mode={undefined}
                      victim={victim}
                      setJudgementOnMeritsRequest={
                        props.setJudgementOnMeritsRequest
                      }
                      judgementOnMeritsRequest={props.judgementOnMeritsRequest}
                      listings={props.listings}
                      judgementAddDocuments={props.judgementAddDocuments}
                      isDisabled={false}
                    />
                  )}
                </Grid>
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  );
};

export default injectIntl(InjuredVictim);
